import { HttpHandlerFn, HttpInterceptorFn, HttpRequest } from '@angular/common/http';
import { inject } from '@angular/core';
import { from, switchMap } from 'rxjs';

import { OidcAuthService } from '../services/auth';
import { DomainListService } from '../services/domain-list/domain-list.service';

export const authInterceptorFn: HttpInterceptorFn = (req: HttpRequest<unknown>, next: HttpHandlerFn) => {
    const oidcAuthService = inject(OidcAuthService);
    const domainListService = inject(DomainListService);

    let token = oidcAuthService.getToken();
    if (token && domainListService.isWhitelistedDomain(req) && !domainListService.isBlacklistedRoute(req)) {
        return from(oidcAuthService.refreshTokenIfExpired()).pipe(
            switchMap((status) => {
                // If the token refresh was successful, update the token
                if (status.status === 'SUCCESS') {
                    token = status.accessToken;
                }

                return next(req.clone({ headers: req.headers.set('Authorization', `Bearer ${token}`) }));
            })
        );
    }
    return next(req);
};
